export const SAVE_ALL_COST_CENTERS = 'SAVE_ALL_COST_CENTERS'
